(() => {
  const initTilt = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-culm-tilt]').forEach((el) => {
      const strength = Number(el.dataset.culmTiltStrength || 5);
      const move = (event) => {
        const r = el.getBoundingClientRect();
        const x = (event.clientX - r.left) / r.width - .5;
        const y = (event.clientY - r.top) / r.height - .5;
        el.style.setProperty('--ry', `${x * strength * 2}deg`);
        el.style.setProperty('--rx', `${-y * strength * 2}deg`);
        el.style.setProperty('--mx', `${x * 55}`);
        el.style.setProperty('--my', `${y * 55}`);
      };
      const reset = () => {
        el.style.setProperty('--ry', '0deg');
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--mx', '0');
        el.style.setProperty('--my', '0');
      };
      el.addEventListener('pointermove', move, { passive: true });
      el.addEventListener('pointerleave', reset, { passive: true });
    });
  };

  const initMedia = () => {
    document.querySelectorAll('[data-culm-media-gallery]').forEach((gallery) => {
      const root = gallery.closest('.culm-shirt-product__visual') || gallery.parentElement;
      const panels = [...gallery.querySelectorAll('[data-culm-media-panel]')];
      const thumbs = [...root.querySelectorAll('[data-culm-media-target]')];
      thumbs.forEach((button) => button.addEventListener('click', () => {
        const id = button.dataset.culmMediaTarget;
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.culmMediaPanel === id));
        thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
      }));
    });
  };

  const initVariants = () => {
    document.querySelectorAll('[data-culm-shirt-form]').forEach((form) => {
      const data = form.querySelector('[data-culm-variants]');
      if (!data) return;
      let variants = [];
      try { variants = JSON.parse(data.textContent); } catch (_) { return; }
      const selects = [...form.querySelectorAll('[data-culm-option]')];
      const idInput = form.querySelector('input[name="id"]');
      const button = form.querySelector('[data-culm-buy]');
      const price = document.querySelector(`[data-culm-price="${form.dataset.culmSection}"]`);
      const compare = document.querySelector(`[data-culm-compare="${form.dataset.culmSection}"]`);
      const update = () => {
        const chosen = selects.map((select) => select.value);
        const variant = variants.find((item) => item.options.length === chosen.length && item.options.every((value, index) => value === chosen[index]));
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (price) price.textContent = variant.price;
        if (compare) {
          compare.textContent = variant.compare || '';
          compare.hidden = !variant.compare;
        }
        if (button) {
          button.disabled = !variant.available;
          const label = button.querySelector('span');
          if (label) label.textContent = variant.available ? 'Add to bag' : 'Unavailable';
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };
      selects.forEach((select) => select.addEventListener('change', update));
    });
  };

  const initShare = () => {
    const product = document.querySelector('[data-culm-product-context]');
    if (!product || product.querySelector('[data-culm-product-share]')) return;
    const insertionPoint = product.querySelector('.culm-shirt-private');
    if (!insertionPoint) return;

    const title = product.dataset.productTitle || document.querySelector('h1')?.textContent?.trim() || document.title;
    const shareUrl = new URL(window.location.href);
    shareUrl.hash = '';
    const canonical = document.querySelector('link[rel="canonical"]')?.href;
    if (canonical) {
      try {
        const canonicalUrl = new URL(canonical);
        const variant = shareUrl.searchParams.get('variant');
        if (variant) canonicalUrl.searchParams.set('variant', variant);
        shareUrl.href = canonicalUrl.href;
      } catch (_) {}
    }
    const url = shareUrl.toString();
    const image = document.querySelector('meta[property="og:image"]')?.content || '';
    const message = `CULM — ${title}`;

    const wrap = document.createElement('div');
    wrap.className = 'culm-product-share';
    wrap.dataset.culmProductShare = '';
    wrap.innerHTML = `
      <div class="culm-product-share__row">
        <span class="culm-mono">Share garment</span>
        <button class="culm-product-share__trigger" type="button" data-culm-share-trigger aria-expanded="false" aria-controls="CulmSharePanel">
          <span>Share</span><span aria-hidden="true">↗</span>
        </button>
      </div>
      <div class="culm-product-share__panel" id="CulmSharePanel" data-culm-share-panel hidden>
        <button type="button" data-culm-copy-link>Copy link</button>
        <a data-culm-share-whatsapp target="_blank" rel="noopener noreferrer">WhatsApp</a>
        <a data-culm-share-x target="_blank" rel="noopener noreferrer">X</a>
        <a data-culm-share-facebook target="_blank" rel="noopener noreferrer">Facebook</a>
        <a data-culm-share-pinterest target="_blank" rel="noopener noreferrer">Pinterest</a>
        <p class="culm-mono culm-product-share__status" data-culm-share-status role="status" aria-live="polite"></p>
      </div>`;
    insertionPoint.parentNode.insertBefore(wrap, insertionPoint);

    const trigger = wrap.querySelector('[data-culm-share-trigger]');
    const panel = wrap.querySelector('[data-culm-share-panel]');
    const status = wrap.querySelector('[data-culm-share-status]');
    const setOpen = (open) => {
      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
      wrap.classList.toggle('is-open', open);
    };

    wrap.querySelector('[data-culm-share-whatsapp]').href = `https://wa.me/?text=${encodeURIComponent(`${message} ${url}`)}`;
    wrap.querySelector('[data-culm-share-x]').href = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&url=${encodeURIComponent(url)}`;
    wrap.querySelector('[data-culm-share-facebook]').href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    wrap.querySelector('[data-culm-share-pinterest]').href = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(image)}&description=${encodeURIComponent(message)}`;

    trigger.addEventListener('click', async () => {
      const mobileLike = window.matchMedia('(pointer: coarse)').matches || window.innerWidth <= 760;
      if (navigator.share && mobileLike) {
        try {
          await navigator.share({ title: message, text: title, url });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }
      setOpen(panel.hidden);
    });

    wrap.querySelector('[data-culm-copy-link]').addEventListener('click', async (event) => {
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
          copied = true;
        }
      } catch (_) {}
      if (!copied) {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try { copied = document.execCommand('copy'); } catch (_) {}
        textarea.remove();
      }
      status.textContent = copied ? 'Link copied.' : 'Copy the address from your browser.';
      event.currentTarget.textContent = copied ? 'Copied' : 'Copy link';
      window.setTimeout(() => { event.currentTarget.textContent = 'Copy link'; status.textContent = ''; }, 2200);
    });

    document.addEventListener('click', (event) => {
      if (!panel.hidden && !wrap.contains(event.target)) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        setOpen(false);
        trigger.focus();
      }
    });
  };

  const ready = () => { initTilt(); initMedia(); initVariants(); initShare(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
